import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LogoutRequested } from '../store/auth/auth.actions';

@Injectable()
export class AuthenticationService {
  constructor(private store: Store) {}

  logOut(){
    this.store.dispatch(LogoutRequested());
  }
}
